import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class ScanEngine extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'scanEngine';

	getCombobox() {
		let request = {
			url: `${this.getAPIUrl()}/combobox`
		};

		return httpClient.getAsync(request);
	}
}

export default new ScanEngine();
